import React, { useState, useEffect } from 'react';
import {
    FaUserNurse,
    FaWalking,
    FaHandHoldingHeart,
    FaUserFriends,
    FaHandsHelping,
    FaBaby,
    FaBroom,
    FaUtensils,
    FaArrowRight
} from 'react-icons/fa';
import { getServices } from '../utils/api';
import './Services.css';

const iconMap = {
    FaUserNurse: FaUserNurse,
    FaWalking: FaWalking,
    FaHandHoldingHeart: FaHandHoldingHeart,
    FaUserFriends: FaUserFriends,
    FaHandsHelping: FaHandsHelping,
    FaBaby: FaBaby,
    FaBroom: FaBroom,
    FaUtensils: FaUtensils
};

const Services = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchServices();
    }, []);

    const fetchServices = async () => {
        try {
            const data = await getServices();
            setServices(data.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching services:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="services section" id="services">
                <div className="container">
                    <div className="spinner"></div>
                </div>
            </section>
        );
    }

    return (
        <section className="services section" id="services">
            <div className="container">
                <div className="section-header text-center">
                    <span className="section-tag">Our Services</span>
                    <h2 className="section-title">
                        Premium Healthcare & <span className="text-gradient">Domestic Services</span>
                    </h2>
                    <p className="section-description">
                        Comprehensive care solutions tailored to your needs with professionally trained staff
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => {
                        const IconComponent = iconMap[service.icon] || FaHandHoldingHeart;
                        return (
                            <div className="service-card card" key={index}>
                                <div className="service-icon">
                                    <IconComponent />
                                </div>
                                <h3 className="service-title">{service.title}</h3>
                                <p className="service-description">{service.description}</p>
                                <div className="service-price">{service.price}</div>
                                <ul className="service-features">
                                    {service.features && service.features.map((feature, idx) => (
                                        <li key={idx}>
                                            <span className="feature-check">✓</span> {feature}
                                        </li>
                                    ))}
                                </ul>
                                <a href="tel:9082033873" className="service-btn">
                                    Book Now <FaArrowRight />
                                </a>
                            </div>
                        );
                    })}
                </div>

                <div className="services-cta">
                    <p>Need a custom package? Contact us for personalized service plans</p>
                    <a href="tel:9082033873" className="btn btn-primary">
                        Call 9082033873
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Services;